import { useStoreActions } from "../contexts";
import { useEventReporter } from "../event-reporter";
import { handleRequest } from "../infra/utils";
export let LoginMethod = /*#__PURE__*/function (LoginMethod) {
  LoginMethod["Password"] = "password";
  LoginMethod["OTP"] = "otp";
  LoginMethod["Google"] = "google";
  LoginMethod["Xero"] = "xero";
  LoginMethod["Intuit"] = "intuit";
  return LoginMethod;
}({});
export function useSendLoginGtmEvents() {
  const {
    sendEventToGtm
  } = useEventReporter();
  const {
    api
  } = useStoreActions();
  return {
    async sendGtmLoginSuccessEvent(method) {
      const userInfo = await handleRequest(api.auth.getUserInfo());
      if (userInfo.data) {
        sendEventToGtm('login_success', {
          user_id: userInfo.data.id(),
          method
        });
      }
    },
    sendGtmLoginFailEvent(method, failReason) {
      sendEventToGtm('login_fail', {
        method,
        fail_reason: failReason || 'unknown'
      });
    }
  };
}